/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import {
    bool,
    func,
    number,
    object,
} from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import style from './FloatingProgressBar.module.css';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import ProgressBar from './ProgressBar';
import { getBrand } from '../../../../../../../pages/Account/state/ducks/Common/Common-Selectors';
import byoTheme from './BYOTheme';

const FloatingProgressBar = ({
    maxSelectableForSku,
    activeStep,
    totalProductSelected,
    disabledButton,
    nextStep,
    selectedSku,
    desktop,
    handleItemRemove,
}) => {
    const brandData = useSelector(getBrand);
    const brandCode = brandData?.code;
    const {
        nextButtonColor = '#ffffff',
        nextButtonBg = '#a1001a',
        previousButtonColor = '#a1001a',
        buttonColorClear = '#512C1C',
    } = byoTheme[brandCode] || {};
    useStyles(style);
    const dispatch = useDispatch();
    return (

        <div className={style.floatingProgressBarContainer}>
            <div id="progressBar" className={style.floatingProgressBar}>
                <ProgressBar
                    totalProductSelected={totalProductSelected}
                    maxSelectableForSku={maxSelectableForSku}
                    floatingProgressBar
                />
                <button
                    type="button"
                    color="primary"
                    id="Next_Button"
                    disabled={disabledButton}
                    className={style.buttonContainer}
                    tabIndex={-1}
                    style={{
                        '--btn-next-color': nextButtonColor,
                        '--btn-next-bg': nextButtonBg,
                        '--btn-previous-color': previousButtonColor,
                    }}
                    onClick={() => {
                        nextStep(activeStep);
                        dispatch(trackEvent({
                            eventCategory: 'BYO',
                            eventAction: 'Next button Clicked',
                            eventLabel: `Navigated to step #${activeStep + 1}` || '',
                        }));
                        dispatch(trackEvent({
                            eventCategory: 'BYO – Complete Step',
                            eventAction: activeStep,
                            eventLabel: selectedSku?.id || '',
                            eventName: 'BYO_step_complete',
                            step: activeStep,
                            byo_variant: selectedSku?.id || '',
                        }));
                    }}
                >
                    Next
                </button>
                {desktop && totalProductSelected >= 1 && (
                    <span
                        className={style.clearSelection}
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        onKeyDown={() => {}}
                        tabIndex={-1}
                        role="button"
                        style={{
                            '--btn-color-clear': buttonColorClear,
                        }}
                        onClick={() => {
                            handleItemRemove();
                            dispatch(trackEvent({
                                eventCategory: 'BYO',
                                eventAction: 'Progress bar Clear Selections',
                                eventLabel: 'Removed all items',
                            }));
                        }}
                    >
                        <strong>Clear Selections</strong>
                    </span>
                )}
            </div>

        </div>

    );
};
FloatingProgressBar.propTypes = {
    totalProductSelected: number,
    maxSelectableForSku: number,
    activeStep: number,
    disabledButton: bool,
    nextStep: func,
    selectedSku: object,
    desktop: bool,
    handleItemRemove: func,
};
FloatingProgressBar.defaultProps = {
    maxSelectableForSku: 0,
    totalProductSelected: 0,
    activeStep: 0,
    disabledButton: true,
    nextStep: () => {},
    selectedSku: {},
    desktop: false,
    handleItemRemove: () => {},
};
export default FloatingProgressBar;
